import { render } from "./LayoutPage.vue?vue&type=template&id=397fbf72&scoped=true"
import script from "./LayoutPage.vue?vue&type=script&lang=js"
export * from "./LayoutPage.vue?vue&type=script&lang=js"

import "./LayoutPage.vue?vue&type=style&index=0&id=397fbf72&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-397fbf72"]])

export default __exports__